// Microservice reference constants

export const Services = {
  IAM: 'iam',
  FLEET: 'fleet',
  CRM: 'crm',
  CRM_BFF: 'crm-bff',
  NOTIFICATIONS: 'notifications',
  BILLING: 'billing',
  ASSETS: 'asset',
  ANALYTICS: 'analytics',
  SCHEDULING: 'scheduling',
  TICKETING: 'ticketing',
  INTEGRATIONS: 'integrations',
  SYSTEM: 'system',
  PRODUCTS: 'product',
} as const

export type ServiceKey = keyof typeof Services

export type ServiceName = (typeof Services)[ServiceKey]

export const getService = (key: ServiceKey): ServiceName => Services[key]
